import { Time } from '@funkey/shared';
import type { TRPC_ROUTER } from '~/modules/trpc/routers';

export const CART_COOKIE_NAME = 'cartId' as const;

export const CART_COOKIE_BASE_OPTIONS = {
    path: '/',
    maxAge: Time.seconds({ days: 30 }),
} as const;

type CartItem = NonNullable<TRPC_ROUTER.output<typeof TRPC_ROUTER.cart.get>>['items'][number];
export type CartItemsGrouped = {
    all: CartItem[];
    available: CartItem[];
    unavailable: CartItem[];
};
